import {CONST} from "../../../src/const";

class GameStrip extends SlotGame.src.component.ReelsetComponent.src.Strip {

    protected notUsableSymbols = [0,1,2,11,12];
    protected usableSymbols = [3,4,5,6,7,8,9,10];
    protected rows = CONST.ROWS + 1;
    constructor(list: any) {
        super(list)
        this.list = list;
        this.index = this.getIndex();
    }
    getNextSymbolId(isNeedToCheck?:boolean): any {
        this.index = this.index % this.symbols.length | 0;
        if (isNeedToCheck && this.notUsableSymbols.includes(Number(this.symbols[this.index]))) {
            this.index++;
            return this.usableSymbols[Math.floor((this.usableSymbols.length) * Math.random())];

        }
        return this.symbols[this.index++];
    }
    getIndex(): any {
        const index = Number(Math.floor(Math.random() * (this.symbols.length - this.rows))) | 0;
        //check if extraSymbolsOnTop need to change SAST-144
        if (this.notUsableSymbols.includes(Number(this.list[index]))) {
            return this.getIndex();
        }
        //check if extraSymbolsOnBottom need to change SAST-144
        if (this.notUsableSymbols.includes(Number(this.list[index + this.rows]))) {
            return this.getIndex();
        }

        return index;
    }
}

export { GameStrip };

SlotGame.src.component.ReelsetComponent.src.Strip = GameStrip;
